import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterOutlet } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { Subscription } from 'rxjs';
import { NotificationService } from './services/notification.service';
import { PresenceService } from './services/presence.service';
import { TabService } from './core/services/tab.service';
@Component({
    selector: 'app-root',
    imports: [CommonModule, RouterOutlet, ToastModule],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'voicebot-client';
  private readonly tabService = inject(TabService);
  private readonly router = inject(Router);

  notification: string | null = null;
  private notificationSubscription: Subscription;
  private duplicateSubscription: Subscription;

  constructor(
    private notificationService: NotificationService,
    private presenceService: PresenceService,
  ) {}

  ngOnInit() {
    this.notificationSubscription = this.notificationService.getNotification()
      .subscribe(message => {
        this.notification = message;
      });

    // Enforce single-tab ownership continuously, not only at route activation.
    this.duplicateSubscription = this.tabService.isDuplicate$.subscribe((isDuplicate) => {
      if (isDuplicate && this.router.url !== '/duplicate-tab') {
        this.presenceService.stop();
        this.router.navigate(['/duplicate-tab']);
        return;
      }

      if (!isDuplicate) {
        this.presenceService.start();
      }
    });

    void this.initializeTabState();
  }

  ngOnDestroy() {
    this.presenceService.stop();
    if (this.notificationSubscription) {
      this.notificationSubscription.unsubscribe();
    }
    if (this.duplicateSubscription) {
      this.duplicateSubscription.unsubscribe();
    }
  }

  hideNotification() {
    this.notificationService.hideNotification();
  }

  private async initializeTabState(): Promise<void> {
    await this.tabService.awaitInitialCheck();

    if (this.tabService.isDuplicateSnapshot()) {
      if (this.router.url !== '/duplicate-tab') {
        this.router.navigate(['/duplicate-tab']);
      }
      return;
    }

    this.presenceService.start();
  }
}
